const SYSTEMS = {
    MAC: 'MAC',
    IOS: 'iOS',
    WINDOWS: 'Windows',
    ANDROID: 'Android',
    LINUX: 'Linux',
}

const getOS = () => {
    const { userAgent } = window.navigator
    const { platform } = window.navigator
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']

    if (macosPlatforms.indexOf(platform) !== -1) {
        return SYSTEMS.MAC
    } if (iosPlatforms.indexOf(platform) !== -1) {
        return SYSTEMS.IOS
    } if (windowsPlatforms.indexOf(platform) !== -1) {
        return SYSTEMS.WINDOWS
    } if (/Android/.test(userAgent)) {
        return SYSTEMS.ANDROID
    } if (/Linux/.test(platform)) {
        return SYSTEMS.LINUX
    }

    return null
}

export const isMacOs = getOS() === SYSTEMS.MAC
export const isWindows = getOS() === SYSTEMS.WINDOWS
export const isLinux = getOS() === SYSTEMS.LINUX

export default {
    getOS,
    isMacOs,
    isWindows,
    isLinux,
}
